/*
 * @Description: 商品列表
 * @Author: yongyao
 * @Date: 2020-02-19 14:33:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: yyyy-08-Mo 09:13:39
*/

// import Vue from 'vue'
import {
    mapState,
    mapActions
} from 'vuex'
import {
    Search,
    Toast,
    Popup
} from 'vant'
import viewName from '../constant.js'
import {
    getGoodsList
} from '@/models/goodsList'
// import {
//     getClosestSstores,
// } from '@/models/marketingDetail'

import QualityImg from '@/components/qualityImg/qualityImg.vue'

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.goodsList,
    components: {
        Search,
        Toast,
        Popup,
        QualityImg
    },
    data () {
        return {
            goodsList: [], // 商品列表数据
            params: { // 请求参数
                page: 1,
                pageSize: 10,
                search_keyword: '', // 搜索关键字
            },
            sstore_id: '',
            hasData: true,
            jumpGoodsParam: {}, // 跳转商品详情请求参数
            topic_id: '',
            latitude: '',
            longitude: '',
            isPosition: '', // 是否获取当前位置
            current_price: '', // 所选的商品的价格
            infiniteId: new Date(),
            loadData: false,
            fetchData: false,
            page_code: '', // 来源页面
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        }),
    },
    created () {
        this.setTitle()
    },
    mounted () {
        this.topic_id = this.$route.query.topic_id
        this.latitude = this.$route.query.latitude
        this.longitude = this.$route.query.longitude
        this.isPosition = this.$route.query.isPosition
        this.page_code = this.$route.query.page_code
        document.body.scrollIntoView()
        // 监听页面滚动
        this.getGoodsListData()
        window.addEventListener('scroll', this.scrollLoad)
    },
    activated () {

    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getClosestSstores',
        ]),
        setTitle () {
            this.setAppClass({
                isAppend: false,
                className: 'bgGreyColor'
            })
        },
        // 请求列表页数据
        getGoodsListData () {
            let {
                sstore_id,
                activity_id,
                floor_id
            } = this.$route.query
            this.sstore_id = sstore_id
            let {
                page,
                pageSize,
                search_keyword
            } = this.params
            this.fetchData = false
            this.showLoading()
            return new Promise(async (resolve, reject) => {
                getGoodsList({
                    'sstore_id': sstore_id,
                    'activity_id': activity_id,
                    'floor_id': floor_id,
                    'page': page,
                    'pagesize': pageSize,
                    'search_keyword': search_keyword,
                    'topic_id': this.topic_id
                }).then(res => {
                    this.hideLoading()
                    const list = res.goods_list
                    this.$emit('setHeader', {
                        title: res.floor_name ? res.floor_name : '商品列表',
                        showHeader: true,
                        showLeft: true
                    })
                    this.goodsList = this.goodsList.concat(list)
                    if (list.length && list.length === this.params.pageSize) {
                        this.params.page++
                        this.loadData = true
                    } else {
                        this.loadData = false
                        this.hasData = false
                    }
                    this.fetchData = true
                }).catch(res => {
                    resolve(res)
                    this.hideLoading()
                })
            })
        },
        scrollLoad () {
            // 真实内容的高度
            var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight)
            // 视窗的高度
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
            // 隐藏的高度
            var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
            if (pageHeight - viewportHeight - scrollHeight < 50 && this.loadData && this.fetchData) { // 如果满足触发条件，执行
                this.getGoodsListData()
            }
        },
        // 点击键盘的确定键，完成搜索
        onSearch (val) {
            // 重置当前页码数和列表数据数据
            this.goodsList = []
            this.params.page = 1
            this.getGoodsListData()
        },
        onBlurSearvh () {
            this.goodsList = []
            this.params.page = 1
            this.getGoodsListData()
        },
        // 跳转商品详情
        toGoodsDetail (goods_id, spu_id, goods_type, current_price, spec_id) {
            if (this.sstore_id) {
                const query = {
                    goods_id,
                    spu_id,
                    sstore_id: this.sstore_id,
                    goods_type,
                    spec_id,
                    page_code: this.page_code
                }
                this.$router.push({
                    path: 'goodsDetail',
                    query
                })
            } else {
                // 多店的商品详情
                let param = {
                    // topic_id: this.topic_id,
                    goods_id,
                    spec_id,
                    spu_id,
                    page_code: this.page_code
                }
                this.$router.push({
                    name: 'moreSstoreGoodsDetail',
                    query: param
                })
            }
        },
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollLoad)
    },
    beforeRouteLeave (to, from, next) {
        // if (to.name === 'specialActivity' || to.name === 'marketingDetail' || to.name === 'mergeSpread') {
        // } else {
        //     to.meta.keepAlive = false
        // }
        // next()
        next(vm => {
            vm.path = from.path
        })
    }
}
